
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56 28a28 28 0 10-56 0h2.8a25.2 25.2 0 1150.4 0H56z","fill":"#D3D3D3"}}),_c('path',{attrs:{"d":"M28 0A28 28 0 000 28h2.8A25.2 25.2 0 0128 2.8V0z","fill":"#42B85C"}})])
          )
        }
      }
    